angular.module('imgEditorCanvasModule').factory('trsEditImgService', ['$q', '$modal', function ($q, $modal) {
    return {
        // 上传文件弹窗

        // var params = {
        //     image: {
        //         PERPICURL: '/wcm/file/read_image.jsp?FileName=U020200722572564937414.jpg',   // 图片地址
        //         APPFILE: 'U020200722572564937414.jpg'                                        // 图片名称
        //     },
        //
        //     cropperOption: {},     // cropper 插件配置项
        //
        //     siteId: '460',         // 站点ID, 目前已知 客户端、网站使用  // 非必填
        //     channelId: ''          // 渠道ID, 目前已知 微信使用         // 非必填
        // };

        editImg: function (dlgOption) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: './components/directive/imgEditorCanvas/imgEditorCanvas_tpl.html',
                windowClass: 'trs-edit-img-dlg',
                backdrop: false,
                keyboard: false,
                controller: 'editImgCtrl',
                resolve: {
                    dlgOption: function () {
                        return angular.copy(dlgOption);
                    }
                }
            });
            // 关闭弹窗
            modalInstance.result.then(function (result) {
                deffer.resolve(result);
            }, function () {
                deffer.reject('cancle');
            });
            return deffer.promise;
        }
    };
}]);
